import request from '@/router/axios'
import env from '@/config/env'

// 获取诉讼分页
export const pageApi = (params) => {
  return request({
    url: env.officeUrl + '/lawsuit/page',
    method: 'POST',
    data: params
  })
}

// 获取诉讼枚举
export const getLawsuitEnum = () => {
  return request({
    url: env.officeUrl + '/lawsuit/enum',
    method: 'get'
  })
}

// 保存诉讼
export const lawsuitSave = (params) => {
  return request({
    url: env.officeUrl + '/lawsuit/save',
    method: 'post',
    data: params
  })
}

// 处理诉讼
export const handleLawsuit = (params) => {
  return request({
    url: env.officeUrl + '/lawsuit/handle',
    method: 'post',
    data: params
  })
}

// 获取诉讼详情
export const lawsuitDetail = (params) => {
  return request({
    url: env.officeUrl + '/lawsuit/detail',
    method: 'get',
    params
  })
}
// 获取处理信息
export const lawsuitHandleDetail = (params) => {
  return request({
    url: env.officeUrl + '/lawsuit/handle/detail',
    method: 'get',
    params
  })
}

// 获取诉讼文档分页
export const docPageApi = (params) => {
  return request({
    url: env.officeUrl + '/lawsuit/doc/page',
    method: 'POST',
    data: params
  })
}

// 保存诉讼文档
export const lawsuitDocSave = (params) => {
  return request({
    url: env.officeUrl + '/lawsuit/doc/save',
    method: 'post',
    data: params
  })
}

// 获取诉讼文档
export const docDetail = (params) => {
  return request({
    url: env.officeUrl + '/lawsuit/doc/detail',
    method: 'get',
    params
  })
}
